module.exports = __webpack_public_path__ + "img/product4.335e3a30.jpg";